document.addEventListener('alpine:init', () => { 
    Alpine.data('ProductCard', (id) => ({
      id,
      mainSlider: null,
      mainSliderThumbs: null,
      mainProduct: {}, // { id, title, options, variants }
      variantsMetafield: {}, // { id, metadata }
      optionsName: [], // ['Color', 'Size']
      options: {}, // { Color: ['Red', 'Blue'], Size: ['S', 'M'] }
      variants: [], // [{ id, title, options: { Color: 'Red', Size: 'M' }, ... }]
      selectedOptions: {}, // { Color: 'Red', Size: 'M' }
      selectedVariant: null,
      finalVariantIdsMap: {},
      inputVariantId: null, // The variant ID to be used in the input field for the form submission
      skioSellingPlanGroups: [], // Store Skio-specific selling plan groups
      modalOpen: false,
  
      isVisible: false,
      offsetTop: 0,
  
      // Use First image as default
      firstImageVariant: true,
      imgModalSrc: '',

      /** Bundle buy box accordions — must live on ProductCard (no nested x-data) so Alpine sees selectedOptions / selectOption */
      bundleAccordionFuelOpen: true,
      bundleAccordionHydrationOpen: true,
  
      /**
       * Initialize the component with default data
       */
      init() {
        // debugger;
        this.inputVariantId = document.querySelector('.b-skio__form .product-variant-id'); // Get the variant ID input field
  
        this.initSlider(); // Initialize the Splide sliders
        this.parseProductJson();      // Parse the product JSON from the DOM
        this.filterSkioSellingPlans(); // Filter for Skio selling plans only
        this.mapOptions();              // Extract all unique option values 
        this.mapVariants();           // Map all variants with named option objects
        this.selectDefaultOptions();  // Select the default variant and options
        if (this.selectedVariant) {
          this.setSelectedVariantStore(this.selectedVariant);
        }
        this.stickyBanner(); // Initialize sticky banner behavior
        this.initVariantLeadPosition(); // Start at slide 1 if variant-lead slot is present
  
        window.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modalOpen) this.closeModal();
        });
  
        console.log('this.selectedOptions', this.selectedOptions);
      },
  
      // Modal window
      openModal(imgSrc) {
        this.modalOpen = true;
        this.imgModalSrc = imgSrc;
        console.log('Opening modal with image:', imgSrc);
        document.body.classList.add('is-modal-open');
      },
      
      closeModal() {
        this.modalOpen = false;
        this.imgModalSrc = '';
        document.body.classList.remove('is-modal-open');
      },
   
      stickyBanner() {
        const el = document.querySelector('.product-form__buttons.m-skio-variants.m-sticky');
        if (!el) return;
      
        const elchild = el.querySelector('.product-form__sticky');
        if (!elchild) return;
      
        const triggerOffset = el.offsetTop;
        const elementHeight = el.offsetHeight;
        // el.style.height = `${elementHeight}px`;
      
        window.addEventListener('scroll', () => {
          const scrollY = window.scrollY || window.pageYOffset;
      
          if (scrollY > triggerOffset + elementHeight) {
            elchild.classList.add('m-activated');
          } else {
            elchild.classList.remove('m-activated');
          }
        });
      },
   
      // Show the slide corresponding to the selected variant
      showVariantSlide(variant) {
        if (!this.mainSlider || !variant) return;

        // If gallery has a single variant-lead slide — scroll to it so the user sees the new image
        const variantLeadSlide = document.querySelector(`#MainSlider-${this.id} .splide__slide--variant-lead`);
        if (variantLeadSlide) {
          this.mainSlider.go(0);
          return;
        }

        // Fallback: original data-variant-ids logic for non-metafield galleries
        const thumbs = document.querySelectorAll(
          `#ThumbnailSlider-${this.id} .thumbnail-slide[data-variant-ids]`
        );
        let targetIndex = null;

        thumbs.forEach((thumb) => {
          const variantIdsAttr = thumb.getAttribute('data-variant-ids');
          if (!variantIdsAttr) return;
          const variantIds = variantIdsAttr.split(',').map((id) => id.trim());
          if (variantIds.includes(variant.id.toString())) {
            targetIndex = parseInt(thumb.dataset.index, 10);
          }
        });

        if (targetIndex !== null && Number.isFinite(targetIndex)) {
          this.mainSlider.go(targetIndex);
        }
      },
  
      // If a variant-lead slide exists, start gallery at slide 1 (first metafield image)
      initVariantLeadPosition() {
        if (!this.mainSlider) return;
        const variantLeadSlide = document.querySelector(`#MainSlider-${this.id} .splide__slide--variant-lead`);
        if (variantLeadSlide) {
          this.mainSlider.go(1);
        }
      },

      initSlider() {
        this.mainSlider = new Splide(`#MainSlider-${ this.id }`, {
          type: 'slide',
          perPage: 1, 
          rewind: true,
          pagination: false,
          arrows: true,
          breakpoints: {
            749: {
              arrows: false,
              perPage: 1.2, 
              gap: 10,
            },
          },
        });
    
        this.thumbnailSlider = new Splide(`#ThumbnailSlider-${ this.id }`, {
          perPage: 4.5,
          gap: 15,
          rewind: true,
          pagination: false,
          isNavigation: true,
          arrows: false,
          breakpoints: {
            640: {
                perPage: 3.5,
                gap: 10,
            },
          }, 
        });
    
        this.mainSlider.sync(this.thumbnailSlider);
        this.mainSlider.mount();
        this.thumbnailSlider.mount();
      },
   
      /** 
       * Parse the product JSON from a DOM reference
       */
      parseProductJson() {
        const productData = JSON.parse(this.$refs.productDataJson.textContent);
        const productVariantsMetafieldJson = JSON.parse(this.$refs.productVariantsMetafieldJson.textContent);
        this.mainProduct = productData;
        this.variantsMetafield = productVariantsMetafieldJson;
        this._bundleMatrixRows = null;
        console.log('this.mainProduct', this.mainProduct);
        console.log('this.variantsMetafield', this.variantsMetafield);
      },
  
      /**
       * Filter selling plan groups to only include Skio plans
       */
      filterSkioSellingPlans() {
        this.skioSellingPlanGroups = window.CtrSkioPlans.skioGroups(this.mainProduct);
        
        console.log('Skio selling plan groups:', this.skioSellingPlanGroups);
        
        // Get all Skio selling plan IDs for easy lookup
        this.skioSellingPlanIds = new Set();
        this.skioSellingPlanGroups.forEach(group => {
          group.selling_plans?.forEach(plan => {
            this.skioSellingPlanIds.add(plan.id);
          });
        });
        
        console.log('Skio selling plan IDs:', Array.from(this.skioSellingPlanIds));
      },
  
      /**
       * Check if a selling plan allocation is from Skio
       * @param {Object} allocation - The selling plan allocation
       * @returns {Boolean}
       */
      isSkioSellingPlan(allocation) {
        return this.skioSellingPlanIds?.has(allocation.selling_plan_id) || false;
      },
  
      /**
       * Get Skio selling plan by ID
       * @param {Number} planId - The selling plan ID
       * @returns {Object|null} - The selling plan object or null
       */
      getSkioSellingPlan(planId) {
        for (const group of this.skioSellingPlanGroups) {
          const plan = group.selling_plans?.find(sp => sp.id === planId);
          if (plan) return plan;
        }
        return null;
      },
  
      /**
       * Initialize the component with a new product
       * @param {Object} product - The new product object
       */
      initNewProduct(product) {
        this.mainProduct = product;
        this.init();
        this.initAccordions();
      },
  
      /**
       * Map all available product options and their unique values
       */ 
      mapOptions() { 
        this.options = {};
        this.optionsName = [];
      
        this.mainProduct.options.forEach((option, index) => {
          const key = `option${index + 1}`;
          this.optionsName.push(option);
          this.options[key] = this.mainProduct.variants
            .map(v => v.options[index])
            .filter((value, i, arr) => arr.indexOf(value) === i);
        });
      },
  
      /** 
       * Create a normalized list of variants with key-value pair options
       * Only include Skio selling plan allocations
       */
      mapVariants() {
        const matrixById = {};
        try {
          const el = this.$el?.querySelector?.('.ctr-bundle-matrix-json');
          if (el?.textContent?.trim()) {
            JSON.parse(el.textContent).forEach((row) => {
              matrixById[String(row.id)] = {
                img: row.img || '',
                mainColor: row.mainColor || '',
              };
            });
          }
        } catch (e) {
          console.warn('bundle matrix parse in mapVariants', e);
        }

        this.variants = this.mainProduct.variants.map((variant) => {
          const optionsObj = {};

          this.mainProduct.options.forEach((opt, i) => {
            const key = `option${i + 1}`;
            optionsObj[key] = variant.options[i];
          });

          const rawAllocations = variant.selling_plan_allocations || [];
          let skioAllocations = rawAllocations.filter((allocation) =>
            this.isSkioSellingPlan(allocation)
          );
          if (skioAllocations.length === 0 && rawAllocations.length > 0) {
            skioAllocations = rawAllocations;
          }

          const matchedMeta = this.variantsMetafield?.find((m) => m.id === variant.id);
          const row = matrixById[String(variant.id)] || { img: '', mainColor: '' };
          return {
            ...variant,
            optionsMapped: optionsObj,
            selling_plan_allocations: skioAllocations,
            metafields: matchedMeta?.metafields || {},
            bundleHydrationImg: row.img,
            bundleHydrationMainColor: row.mainColor,
          };
        });
        console.log('this.variants', this.variants);
      },
  
    /**
     * Set the default selected options.
     * If the URL contains a ?variant=ID, use that variant's options.
     * Otherwise, fallback to the first available variant.
     */
    selectDefaultOptions() { 
        if (this.variants.length === 0) return;
    
        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromUrl = urlParams.get('variant');
    
        if (variantIdFromUrl && /^\d+$/.test(variantIdFromUrl)) {
            const matchedVariant = this.variants.find(v => v.id.toString() === variantIdFromUrl);
            
            if (matchedVariant) {
                this.selectedOptions = { ...matchedVariant.optionsMapped };
                this.selectedVariant = matchedVariant;
                const lastKey = `option${this.optionsName.length}`;
              
                this.updateFinalVariantMap(lastKey);
                return;
            }
        }

        // First available variant, else first row (same idea as standard PDP default)
        const defaultVariant = this.variants.find((v) => v.available) || this.variants[0];
        this.selectedOptions = { ...defaultVariant.optionsMapped };
        this.selectedVariant = defaultVariant;
        const lastKey = `option${this.optionsName.length}`;
        this.updateFinalVariantMap(lastKey);
  
        console.log('this.selectedOptions', this.selectedOptions);
    },
  
      /**
       * Push the currently selected variant to the Alpine store
       * @param {Object} variant - The selected product variant object
       */
      setSelectedVariantStore(variant) {
        // Keep gallery synced with selected flavor/variant on bundle PDP.
        this.showVariantSlide(variant);
  
        if (!variant || typeof variant !== 'object') return;
  
        Alpine.store('ProductStore').set(variant);
        // Set the variant ID in the input field for form submission
        if (this.inputVariantId) {
          this.inputVariantId.value = variant.id;
        }
         
        let skioAllocations = (variant.selling_plan_allocations || []).filter((allocation) =>
          this.isSkioSellingPlan(allocation)
        );
        if (skioAllocations.length === 0) {
          skioAllocations = variant.selling_plan_allocations || [];
        }
        const planId = skioAllocations[0]?.selling_plan_id;

        if (planId) {
          Alpine.store('ProductStore').setSellingPlanForVariant(planId);
        }
      },
  
      /**
       * Update the selected option for a given option name
       * @param {String} name - Option name (e.g. "Option1")
       * @param {String} value - Selected value (e.g. "Red")
       */
      selectOption(name, value) {
          this.selectedOptions[name] = value;
          this.selectVariantFromOption(); 
          const lastKey = `option${this.optionsName.length}`;
          this.updateFinalVariantMap(lastKey);
  
          console.log('this.selectedOptions', this.selectedOptions);
      },
  
      /**
       * Find and set the selected variant based on current selectedOptions
       */
      selectVariantFromOption() {
          this.selectedVariant = this.variants.find(v => {
              return Object.entries(this.selectedOptions).every(([key, value]) => {
              if (value === null || value === undefined) return false;
              return v.optionsMapped[key] === value;
              });
          }) || null;
  
          if (this.selectedVariant) {
              const url = new URL(window.location.href);
              url.searchParams.set('variant', this.selectedVariant.id);
              window.history.replaceState({}, '', url);
              this.setSelectedVariantStore(this.selectedVariant);
              console.log('Selected variant:', this.selectedVariant);
          }
      },
  
      selectVariantById(variantId) {
        
        const matchedVariant = this.variants.find(v => v.id === variantId);
        if (matchedVariant) {
          this.selectedVariant = matchedVariant;
          console.log('Selected variant by ID:', this.selectedVariant);
          this.selectedOptions = { ...matchedVariant.optionsMapped };
          this.setSelectedVariantStore(matchedVariant);
          const lastKey = `option${this.optionsName.length}`;
          this.updateFinalVariantMap(lastKey);
        }
      },

      /**
       * Bundle matrix: show Daily Hydration cells only after Daily Fuel (option1) is chosen.
       * Called from Liquid with JSON-safe option1Value (same string as variant.option1 / optionsMapped).
       */
      /** Parsed from `.ctr-bundle-matrix-json` — one row per variant (dedupe in bundleHydrationChoicesForUI). */
      bundleMatrixRows() {
        if (this._bundleMatrixRows) return this._bundleMatrixRows;
        const el = this.$el?.querySelector?.('.ctr-bundle-matrix-json');
        if (!el?.textContent?.trim()) {
          this._bundleMatrixRows = [];
          return this._bundleMatrixRows;
        }
        try {
          this._bundleMatrixRows = JSON.parse(el.textContent);
        } catch (e) {
          console.warn('bundleMatrixRows parse', e);
          this._bundleMatrixRows = [];
        }
        return this._bundleMatrixRows;
      },

      /** Daily Hydration: exactly one card per option2 for the selected Daily Fuel (option1). */
      bundleHydrationChoicesForUI() {
        const o1 = this.selectedOptions?.option1;
        if (o1 === null || o1 === undefined) return [];
        const rows = this.bundleMatrixRows();
        return rows.filter((r) => String(r.o1) === String(o1));
      },

      /**
       * Variants to show under Daily Hydration — uses JS option values (same as selectOption), not Liquid strings.
       * If option1 is not chosen yet, falls back to the first option1 value so the row is not empty.
       */
      bundleHydrationVariantsVisible() {
        let o1 = this.selectedOptions?.option1;
        if (o1 === null || o1 === undefined || o1 === '') {
          o1 = this.options?.option1?.[0];
        }
        if (o1 === null || o1 === undefined) return [];
        return this.variants.filter((v) => String(v.optionsMapped?.option1) === String(o1));
      },

      /** Daily Fuel swatch: same matrix row as Daily Fuel PDP (pair option1 with first option2 value). */
      bundleFuelSwatchForOption1(o1Val) {
        let canonicalO2 = this.options?.option2?.[0];
        const canonEl = this.$el?.querySelector?.('.ctr-bundle-canonical-o2');
        if (canonEl?.textContent?.trim()) {
          try {
            canonicalO2 = JSON.parse(canonEl.textContent.trim());
          } catch (_) {
            /* keep options.option2[0] */
          }
        }
        if (canonicalO2 === undefined || canonicalO2 === null) return null;
        const rows = this.bundleMatrixRows();
        return (
          rows.find(
            (r) => String(r.o1) === String(o1Val) && String(r.o2) === String(canonicalO2)
          ) || null
        );
      },
  
  
      initAccordions() {
        document.querySelectorAll('[class*="accordion-container--"]').forEach(el => {
          new Accordion(el);
        });
      },
  
      /**
       * Get mapping of option values to variant IDs for the final option level.
       * This can be used to render buttons with attached variant IDs.
       * Uses only Skio selling plan data.
       * @param {String} optionKey - like "option3"
       * @returns {Object} - { "Black": 1234567890, "White": 1234567891 }
       */ 
      updateFinalVariantMap(optionKey) {
        const filtered = this.variants.filter(v => {
          return Object.entries(this.selectedOptions).every(([key, value]) => {
            return key === optionKey || v.optionsMapped[key] === value;
          });
        });
      
        if (filtered.length === 0) {
          this.finalVariantIdsMap[optionKey] = {};
          return;
        }
      
        const map = {};
      
        filtered.forEach(v => {
          let skioAllocations = (v.selling_plan_allocations || []).filter((allocation) =>
            this.isSkioSellingPlan(allocation)
          );
          if (!skioAllocations.length) {
            skioAllocations = v.selling_plan_allocations || [];
          }
          if (!skioAllocations.length) return;

          const allocation = skioAllocations[0];
          const value = v.optionsMapped[optionKey];
          const priceRaw = allocation.price;
          const compareAtRaw = allocation.compare_at_price;
          const sellingPlanId = allocation.selling_plan_id;
      
          // Default to 30 days in a month
          let dayCount = 30;
      
          // Find matching Skio selling plan by ID
          const sellingPlan = this.getSkioSellingPlan(sellingPlanId);
          const sellingPlanName = sellingPlan?.name || '';
      
          // Adjust days based on plan name
          if (sellingPlanName.includes("1 Month")) {
            dayCount *= 1;
          } else if (sellingPlanName.includes("2 Month")) {
            dayCount *= 2;
          } else if (sellingPlanName.includes("3 Month")) {
            dayCount *= 3;
          }
      
          const servingSubscribe = typeof priceRaw === 'number'
            ? (priceRaw / dayCount / 100).toFixed(2)
            : null;
      
          const servingOneTime = typeof compareAtRaw === 'number'
            ? (compareAtRaw / dayCount / 100).toFixed(2)
            : null;
      
          map[value] = {
            id: v.id,
            available: v.available,
            ...(v.metafields ? { metafields: v.metafields } : {}),
            servingSubscribe,
            servingOneTime
          };
        });
      
        this.finalVariantIdsMap = {
          ...this.finalVariantIdsMap,
          [optionKey]: map
        };
      },
  
      hasBadgeValue(key, value, field) {
        const val = this.finalVariantIdsMap?.[key]?.[value]?.metafields?.[field];
        // Check if the value is not null, undefined, or an empty string
        if (val !== undefined && val !== null && val !== '') {
          return true;
        }
          return false;
      },
  
          /**
       * Load the product
       * @param {string} productHandle - The product handle
       * @param {string} preselectedVariantId - The preselected variant ID
       */
      loadProduct(productHandle, preselectedVariantId = "") {
        const isProductPage = window.location.pathname.startsWith('/products/');

        const url = `/products/${productHandle}?${
          preselectedVariantId ? `variant=${preselectedVariantId}` : ""
        }&sections=${this.id}`;
        const productUrl = `/products/${productHandle}.js`;
        let productDetails = null;
        console.log("Loading product:", productHandle, "with section ID:", this.id);
        fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
  
            return response.json();
          })
          .then((product) => {
  
            if (!product[this.id]) {
              console.error("Product section not found");
              return;
            }
            console.log("Loadeded product:", product);
            const container = document.createElement("div");
            container.innerHTML = product[this.id];
            const productDetails = container.querySelector(
              "#MainProduct-" + this.id
            );
  
  
            if (this.$refs.productCardRef) {
              console.log("Replacing product card with new content", productDetails);
              this.$refs.productCardRef.replaceWith(productDetails);
              // this.reExecuteScript();
            } else {
              console.error("Reference to productCardRef not found");
            }
            return fetch(productUrl);
          })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to fetch product data");
            }
          
            return response.json();
          })
          .then((productData) => {
            console.log("Product data loaded:", productData);
  
            this.$nextTick(() => {
              
              this.initNewProduct(productData);
              // Alpine.initTree(productDetails); 
            });
  
            if (isProductPage) {
              window.history.pushState(
                { urlPath: productHandle },
                "",
                `/products/${productHandle}`
              );
            }
            // window.history.pushState(
            //   { urlPath: productHandle },
            //   "", 
            //   productHandle
            // );
          })
          .catch((error) => {
            console.error("Error loading product:", error);
          });
        },
    }));
  });